import React from 'react'
import { useFormContext } from "react-hook-form";


const Inputs = (props) => {

    const { register } = useFormContext();


    return (
        <div>
            <label htmlFor={props.id}>{props.label}</label>
            <input 
                type={props.type} 
                name={props.name.toLowerCase()}
                id={props.id} 
                placeholder={props.placeholder}
                {...register(`${props.name}`)}
                required={props.required}
                defaultValue={props.defaultValue}
                />
        </div>
    )
}

export default Inputs